<template>
  <section>
    <div>
      <carousel-3d
        :width="780"
        :height="350"
        :perspective="0"
        :space="250"
        :controlsVisible="true"
        :controlsHeight="70"
        :controlsWidth="100"
        :border="0"
        :inverseSacling="420"
        :minSwipeDistance="30"
      >
        <slide :index="0" class="rounded-lg overflow-hidden">
          <div class="rounded-3xl relative bg-white overflow-hidden">
            <img
              :src="require(`@/assets/img/image17.webp`)"
              alt=""
              class="object-cover h-full opacity-75"
            />
            <p class="absolute top-1/2 left-1/3 text-white text-3xl font-semibold">Total Body Rest</p>
          </div>
        </slide>
        <slide :index="1">
          <img
            :src="require(`@/assets/img/image16.webp`)"
            alt=""
            class="object-cover h-full opacity-75"
          />
        </slide>
        <slide :index="2">
          <img
            :src="require(`@/assets/img/image15.webp`)"
            alt=""
            class="object-cover h-full opacity-75"
          />
        </slide>
        <slide :index="3">
          <img
            :src="require(`@/assets/img/login.webp`)"
            alt=""
            class="object-cover h-full opacity-75"
          />
        </slide>
        <slide :index="4">
          <img
            :src="require(`@/assets/img/home-banner.webp`)"
            alt=""
            class="object-cover h-full opacity-75"
          />
        </slide>
      </carousel-3d>
    </div>
  </section>
</template>

<script>
import NewSessionCard from "@/components/NewSessionCard";
import { Carousel3d, Slide } from "vue-carousel-3d";

export default {
  name: "TrendingSessionCardListCarousel",
  components: {
    Carousel3d,
    Slide,
    NewSessionCard,
  },
  props: {
    data: {
      type: Array,
    },
    statusCode: {
      type: Number,
    },
  },
};
</script>

<style scoped>
.carousel-3d-slide{
  border-radius: 24px;
}
</style>
